/* eslint-disable react-hooks/exhaustive-deps */
/**
 * B100150 取引先別単価マスタメンテ
 */
import { Column } from "@material-table/core";
import {
  B000150TorihikiNm,
  B000200ShohinNm,
  B000200ShohinNmFrom,
  B000200ShohinNmTo,
  B000202ShohinchubunruiNmFrom,
  B000202ShohinchubunruiNmTo,
  B000202ShohindaibunruiNmFrom,
  B000202ShohindaibunruiNmTo,
  B000202ShohinshobunruiNmFrom,
  B000202ShohinshobunruiNmTo,
  B100150Create,
  B100150CreateRequest,
  B100150Delete,
  B100150DeleteRequest,
  B100150Find,
  B100150FindRequest,
  B100150Update,
  B100150UpdateRequest,
  catchRestError,
} from "clients/rest";
import {
  msgState,
  SCancelButton,
  SConfirmDialog,
  SDateField,
  SEntryTab,
  SFileButton,
  SFrame,
  SLabel,
  SNormalButton,
  SNumberField,
  STable,
  SText,
  STextField,
} from "components";
import { getClientMessage } from "messages";
import { labels } from "messages/labels";
import { B000150, B000200, B000202, GamenInputId } from "pages";
import { createRef, useEffect, useState } from "react";
import { FormProvider, useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { useRecoilState, useRecoilValue, useSetRecoilState } from "recoil";
import { dateWithSlashAt, digit, mapIds } from "services";
import { focusState, navigateTypeState, useFocus } from "states";

// 呼び出し時のプロパティ
type Props = Partial<{
  // 呼び出し元へデータを送る場合に設定する。
  handleSubmit: (data: any) => void;
}>;

// コンポーネントで設定されるフィールドの型を定義する
// ヘッダ部
type Fields = Partial<{
  torihikiCd: string;
  torihikishitenCd: string;
  torihikiNm: string;
  kikanymd: string;
  shohinCdFrom: string;
  shohinNmFrom: string;
  shohinCdTo: string;
  shohinNmTo: string;
  shodaibunFrom: string;
  shohindaibunruiNmFrom: string;
  shodaibunTo: string;
  shohindaibunruiNmTo: string;
  shochubunFrom: string;
  shohinchubunruiNmFrom: string;
  shochubunTo: string;
  shohinchubunruiNmTo: string;
  shoshobunFrom: string;
  shohinshobunruiNmFrom: string;
  shoshobunTo: string;
  shohinshobunruiNmTo: string;
}>;

// タブ部
type TabFields = Partial<{
  tab: boolean;
  torihikiCd: string;
  torihikishitenCd: string;
  shohinCd: string;
  shohinNm: string;
  aiteCd: string;
  defaultKikanFromymd: string;
  kikanFromymd: string | null;
  tanka: string;
  jodaitanka: string;
  version: number;
}>;

//テーブルデータの定義
type Data = Partial<{
  gyoNo: number;
  torihikiCd: string;
  torihikishitenCd: string;
  shohinCd: string;
  shohinNm: string;
  aiteCd: string;
  kikanFromymdF: string;
  kikanFromymd: string;
  tanka: string;
  jodaitanka: string;
  version: number;
}>;

// フィールドの初期値を設定する。
// ヘッダ部
const defaultFields: Fields = {
  torihikiCd: "",
  torihikishitenCd: "",
  torihikiNm: "",
  kikanymd: "",
  shohinCdFrom: "",
  shohinNmFrom: "",
  shohinCdTo: "",
  shohinNmTo: "",
  shodaibunFrom: "",
  shohindaibunruiNmFrom: "",
  shodaibunTo: "",
  shohindaibunruiNmTo: "",
  shochubunFrom: "",
  shohinchubunruiNmFrom: "",
  shochubunTo: "",
  shohinchubunruiNmTo: "",
  shoshobunFrom: "",
  shohinshobunruiNmFrom: "",
  shoshobunTo: "",
  shohinshobunruiNmTo: "",
};

// タブ部
const defaultTabFields: TabFields = {
  tab: true,
  torihikiCd: "",
  torihikishitenCd: "",
  shohinCd: "",
  shohinNm: "",
  aiteCd: "",
  defaultKikanFromymd: "",
  kikanFromymd: null,
  tanka: "",
  jodaitanka: "",
  version: undefined,
};

const columns: Column<Data>[] = [
  { field: "gyoNo", title: "行　", width: "3rem", align: "right" },
  { field: "torihikiCd", hidden: true },
  { field: "torihikishitenCd", hidden: true },
  { field: "shohinCd", title: "商品コード", width: "8rem" },
  { field: "shohinNm", title: "商品名", width: "20rem" },
  { field: "aiteCd", title: "相手コード", width: "8rem" },
  { field: "kikanFromymd", hidden: true },
  { field: "kikanFromymdF", title: "期間開始", width: "10rem" },
  {
    field: "jodaitanka",
    title: "上代　",
    width: "5rem",
    align: "right",
    render: (data) => digit(data.jodaitanka),
  },
  {
    field: "tanka",
    title: "原価　",
    width: "5rem",
    align: "right",
    render: (data) => digit(data.tanka),
  },
  { field: "version", hidden: true },
];

// 固定値
const focusId = "B100150";

// B100150 取引先別単価マスタメンテ
export const B100150 = (props: Props) => {
  useFocus(focusId);
  return <Page {...props} />;
};

const Page = (props: Props) => {
  // 状態管理の初期設定
  // フォーム関数
  const methods = useForm<Fields>({
    mode: "onBlur",
    defaultValues: defaultFields,
  });
  // フォーム関数
  const tabMethods = useForm<TabFields>({
    mode: "onBlur",
    defaultValues: defaultTabFields,
  });

  // テーブル管理
  const tableRef = createRef();
  const [rows, setRows] = useState<Data[]>([]);
  // テーブル行で選択されたデータ
  const [rowData, setRowData] = useState<Partial<Data>>();
  // フォーカス設定
  const { focus, register } = useRecoilValue(focusState(focusId));
  // 遷移元データ取得用
  const navigate = useNavigate();
  // エラー表示
  const setMsg = useSetRecoilState(msgState);
  // 画面遷移の処理
  const [menuNavigate, setMenuNavigate] = useRecoilState(navigateTypeState);

  // 初期表示イベント
  useEffect(() => {
    focus(1);
  }, []);
  // 検索ボタンクリックイベント
  const handleClickSearchButton = () => {
    // 検索フォームのデータを取得する。
    const fields = methods.getValues();

    // タブ部に取引先コード、取引先支店コードをセット
    tabMethods.setValue("torihikiCd", fields.torihikiCd);
    tabMethods.setValue("torihikishitenCd", fields.torihikishitenCd);

    // 検索パラメータを作成する。
    const param: B100150FindRequest = {
      torihikiCd: fields.torihikiCd!,
      torihikishitenCd: fields.torihikishitenCd!,
      kikanymd: fields.kikanymd,
      shohinCdFrom: fields.shohinCdFrom,
      shohinCdTo: fields.shohinCdTo,
      shodaibunFrom: fields.shodaibunFrom,
      shodaibunTo: fields.shodaibunTo,
      shochubunFrom: fields.shochubunFrom,
      shochubunTo: fields.shochubunTo,
      shoshobunFrom: fields.shoshobunFrom,
      shoshobunTo: fields.shoshobunTo,
    };
    // API呼出し
    B100150Find(param)
      .then((value) => {
        // グリッドへのマッピング
        const gridDataList = value.data.map<Data>((value, index) => {
          // 行番号
          const gyoNo: number = index + 1;
          // 行のデータセット
          const data: Data = {
            gyoNo: Number(gyoNo),
            torihikiCd: value.torihikiCd,
            torihikishitenCd: value.torihikishitenCd,
            shohinCd: value.shohinCd,
            shohinNm: value.shohinNm,
            aiteCd: value.aiteCd,
            kikanFromymd: value.kikanFromymd,
            kikanFromymdF: dateWithSlashAt(value.kikanFromymd),
            tanka: value.tanka,
            jodaitanka: value.jodaitanka,
            version: value.version,
          };
          return data;
        });
        // テーブルに反映
        setRows(gridDataList);
      })
      // エラー時
      .catch((reason) => {
        setRows([]);
        catchRestError(reason, navigate, setMsg);
      });
  };

  // 登録
  const handleCreate = () => {
    // タブ部のデータ取得
    const tabFields = tabMethods.getValues();
    // 新規登録するデータの作成
    const newData: B100150CreateRequest = {
      torihikiCd: tabFields.torihikiCd!,
      torihikishitenCd: tabFields.torihikishitenCd!,
      shohinCd: tabFields.shohinCd!,
      aiteCd: tabFields.aiteCd,
      kikanFromymd: tabFields.kikanFromymd!,
      tanka: tabFields.tanka,
      jodaitanka: tabFields.jodaitanka,
    };
    // API呼出し
    B100150Create(newData)
      .then(() => {
        // 新規登録した行の追加
        addRow(newData);
        // タブ部の各項目を初期化する。
        tabMethods.reset();
        tabMethods.setValue("torihikiCd", newData.torihikiCd);
        tabMethods.setValue("torihikishitenCd", newData.torihikishitenCd);
        // 登録完了メッセージ表示
        setMsg(getClientMessage("B100150_001"));
      })
      .catch((reason) => {
        catchRestError(reason, navigate, setMsg);
      });
  };

  // 更新
  const handleUpdate = () => {
    const tabFields = tabMethods.getValues();
    // 更新データ取得
    const updateData: B100150UpdateRequest = {
      torihikiCd: tabFields.torihikiCd!,
      torihikishitenCd: tabFields.torihikishitenCd!,
      shohinCd: tabFields.shohinCd!,
      aiteCd: tabFields.aiteCd,
      defaultKikanFromymd: tabFields.defaultKikanFromymd!,
      kikanFromymd: tabFields.kikanFromymd!,
      tanka: tabFields.tanka,
      jodaitanka: tabFields.jodaitanka,
      version: tabFields.version!,
    };
    // API呼出し
    B100150Update(updateData)
      .then(() => {
        // 更新した行の表示更新
        updateRow(updateData);
        // タブ部の各項目を初期化する。
        tabMethods.reset();
        tabMethods.setValue("torihikiCd", updateData.torihikiCd);
        tabMethods.setValue("torihikishitenCd", updateData.torihikishitenCd);
        // 更新完了メッセージ表示
        setMsg(getClientMessage("B100150_002"));
      })
      .catch((reason) => {
        catchRestError(reason, navigate, setMsg);
      });
  };

  // 削除
  const handleDelete = () => {
    const tabFields = tabMethods.getValues();
    // 削除データ取得
    const delData: B100150DeleteRequest = {
      torihikiCd: tabFields.torihikiCd!,
      torihikishitenCd: tabFields.torihikishitenCd!,
      shohinCd: tabFields.shohinCd!,
      kikanFromymd: tabFields.kikanFromymd!,
    };
    // API呼出し
    B100150Delete(delData)
      .then(() => {
        // 他期間の更新処理
        handleUpdateOtherKikan(rowData?.shohinCd!, rowData?.kikanFromymd!);

        // 選択行の削除処理
        // 選択行の行番号取得
        const gyoNo = rowData?.gyoNo;
        // 取得した行番号の行を除いた全てのデータを取得
        const newRows = rows.filter(function (source: Data) {
          return source.gyoNo !== gyoNo;
        });
        // 明細テーブルの行番号振り直し
        mapIds(newRows, "gyoNo");
        // 削除後のデータセット
        setRows(newRows);
        // タブ部の各項目を初期化する。
        tabMethods.reset();
        tabMethods.setValue("torihikiCd", delData.torihikiCd);
        tabMethods.setValue("torihikishitenCd", delData.torihikishitenCd);
        // 削除完了メッセージ表示
        setMsg(getClientMessage("B100150_003"));
      })
      .catch((reason) => {
        catchRestError(reason, navigate, setMsg);
      });
  };

  // テーブル行ダブルクリックイベント
  const handleDoubleClickTableRow = (rowData: Data) => {
    tabMethods.reset();
    // タブを編集にする
    tabMethods.setValue("tab", false);
    // ダブルクリックした行を選択状態にする
    setRowData(rowData);
    // タブ部にデータを表示する。
    tabMethods.setValue("torihikiCd", rowData.torihikiCd);
    tabMethods.setValue("torihikishitenCd", rowData.torihikishitenCd);
    tabMethods.setValue("shohinCd", rowData.shohinCd);
    tabMethods.setValue("shohinNm", rowData.shohinNm);
    tabMethods.setValue("aiteCd", rowData.aiteCd);
    tabMethods.setValue("defaultKikanFromymd", rowData.kikanFromymd);
    tabMethods.setValue("kikanFromymd", rowData.kikanFromymd);
    tabMethods.setValue("tanka", rowData.tanka?.toString());
    tabMethods.setValue("jodaitanka", rowData.jodaitanka?.toString());
    tabMethods.setValue("version", rowData.version);
  };

  // タブ切り替え
  const handleChangeTab = () => {
    // タブ部の値を初期化
    tabMethods.reset();
    // タブ部に取引先コード、取引先支店コードをセット
    tabMethods.setValue("torihikiCd", rowData?.torihikiCd);
    tabMethods.setValue("torihikishitenCd", rowData?.torihikishitenCd);
    // 行選択解除
    setRowData(undefined);
  };

  // 新規登録行の追加
  const addRow = (newData: B100150CreateRequest) => {
    const gyoNo: number = rows.length + 1;
    const newRowData: Data = {
      gyoNo: gyoNo,
      torihikiCd: newData.torihikiCd,
      torihikishitenCd: newData.torihikishitenCd,
      shohinCd: newData.shohinCd,
      shohinNm: tabMethods.watch("shohinNm"),
      aiteCd: newData.aiteCd,
      kikanFromymd: newData.kikanFromymd,
      kikanFromymdF: dateWithSlashAt(newData.kikanFromymd),
      tanka: newData.tanka,
      jodaitanka: newData.jodaitanka,
      version: 1,
    };

    // 他期間の更新処理
    handleUpdateOtherKikan(newData.shohinCd, newData.kikanFromymd);

    setRows([...rows, newRowData]);
  };

  // 更新行の表示更新
  const updateRow = (updateData: B100150UpdateRequest) => {
    const gyoNo: number = rowData!.gyoNo!;
    const updRowData: Data = {
      gyoNo: gyoNo,
      torihikiCd: updateData.torihikiCd,
      torihikishitenCd: updateData.torihikishitenCd,
      shohinCd: updateData.shohinCd,
      shohinNm: tabMethods.watch("shohinNm"),
      aiteCd: updateData.aiteCd,
      kikanFromymd: updateData.kikanFromymd,
      kikanFromymdF: dateWithSlashAt(updateData.kikanFromymd),
      tanka: updateData.tanka,
      jodaitanka: updateData.jodaitanka,
      version: updateData.version + 1,
    };
    rows[gyoNo - 1] = updRowData;

    // 他期間の更新処理
    handleUpdateOtherKikan(updateData.shohinCd, updateData.kikanFromymd);

    setRows([...rows]);
  };

  // 他期間の更新処理
  const handleUpdateOtherKikan = (shohinCd: string, kikanFromymd: string) => {
    // 明細が設定されていない場合
    if (rows.length === 0) return;

    // 今回分の期間開始日より小さい日付が存在するかチェック
    const isExsists: boolean = rows.some((row) => {
      return row.kikanFromymd! < kikanFromymd;
    });
    if (!isExsists) {
      return;
    }

    // 前回分の期間開始を取得
    const kikanFromymdBefore: string | undefined = rows
      // リスト.期間開始 < 今回分.期間開始で絞り込む
      .filter((row) => row.kikanFromymd! < kikanFromymd)
      .reduce((a, b) =>
        a.kikanFromymd! > b.kikanFromymd! ? a : b
      ).kikanFromymd;

    // 取得できなかった場合
    if (typeof kikanFromymdBefore === "undefined") return;
    if (kikanFromymdBefore === "") return;

    for (const row of rows) {
      // 商品コードが一致しない場合、何もしない
      if (shohinCd !== row.shohinCd) continue;
      // 期間開始が一致しない場合、何もしない
      if (kikanFromymdBefore !== row.kikanFromymd) continue;

      // version更新
      row.version = row.version! + 1;
    }
  };

  // excelボタンクリック時
  const handleMoveOutput = () => {
    // 取引先別単価マスタ出力画面へ遷移する。
    setMenuNavigate("next");
    navigate("/b100153");
  };

  // excel取込ボタンクリック時
  const handleMoveImport = () => {
    const gamenInputId: GamenInputId = {
      gamenId: "100150",
    };

    // マスタ取込画面へ遷移する。
    setMenuNavigate("next");
    navigate("/b100900", { state: gamenInputId });
  };

  // レイアウト設定
  return (
    <>
      <FormProvider {...methods}>
        <SFrame
          title="取引先別単価マスタメンテ"
          gridTemplateColumns="8rem 5rem 5rem 10rem 5rem 1rem 5rem 3rem 12rem 3rem 6rem "
        >
          <SText gridColumn="span 8"></SText>
          <SFileButton
            label={labels.buttons.excel}
            align="right"
            gridColumn="span 2"
            {...register(13)}
            onClick={handleMoveOutput}
          />
          <SNormalButton
            label={labels.buttons.excelImport}
            align="right"
            {...register(14)}
            onClick={handleMoveImport}
          />

          <SLabel required gridColumn="1">
            取引先
          </SLabel>
          <SNumberField
            name="torihikiCd"
            label="取引先コード"
            code
            required
            size={6}
            {...register(1)}
            onBlur={() => B000150TorihikiNm(methods, navigate, setMsg)}
          />
          <SNumberField
            name="torihikishitenCd"
            label="取引先支店コード"
            code
            required
            size={4}
            {...register(2)}
            onBlur={() => B000150TorihikiNm(methods, navigate, setMsg)}
            dialog={<B000150 />}
            handleSubmit={(data: any) => {
              methods.setValue("torihikiCd", data.tokuiCd ?? "");
              methods.setValue("torihikishitenCd", data.tokuishitenCd ?? "");
              methods.setValue("torihikiNm", data.tokuiNmr ?? "");
            }}
          />
          <STextField name="torihikiNm" disabled gridColumn="span 2" />

          <SLabel gridColumn="1">有効日付</SLabel>
          <SDateField
            name="kikanymd"
            label="有効日付"
            gridColumn="span 2"
            {...register(3)}
          />

          <SLabel gridColumn="1">商品コード</SLabel>
          <SNumberField
            name="shohinCdFrom"
            code
            size={10}
            gridColumn="span 2"
            dialog={<B000200 />}
            handleSubmit={(data: any) => {
              methods.setValue("shohinCdFrom", data.shohinCd ?? "");
              methods.setValue("shohinNmFrom", data.shohinNmr ?? "");
            }}
            onBlur={() => B000200ShohinNmFrom(methods, navigate, setMsg)}
            {...register(4)}
          />
          <STextField name="shohinNmFrom" disabled gridColumn="span 2" />
          <SText>～</SText>
          <SNumberField
            name="shohinCdTo"
            code
            size={10}
            gridColumn="span 2"
            dialog={<B000200 />}
            handleSubmit={(data: any) => {
              methods.setValue("shohinCdTo", data.shohinCd ?? "");
              methods.setValue("shohinNmTo", data.shohinNmr ?? "");
            }}
            onBlur={() => B000200ShohinNmTo(methods, navigate, setMsg)}
            {...register(5)}
          />
          <STextField name="shohinNmTo" disabled gridColumn="span 2" />

          <SLabel gridColumn="1">商品大分類コード</SLabel>
          <SNumberField
            name="shodaibunFrom"
            code
            size={3}
            dialog={<B000202 />}
            handleSubmit={(data: any) => {
              methods.setValue("shodaibunFrom", data.shodaibun ?? "");
              (async () => {
                await B000202ShohindaibunruiNmFrom(methods, navigate, setMsg);
              })();
            }}
            onBlur={() =>
              B000202ShohindaibunruiNmFrom(methods, navigate, setMsg)
            }
            {...register(6)}
          />
          <STextField
            name="shohindaibunruiNmFrom"
            disabled
            gridColumn="span 2"
          />
          <SText></SText>
          <SText>～</SText>
          <SNumberField
            name="shodaibunTo"
            code
            size={3}
            dialog={<B000202 />}
            handleSubmit={(data: any) => {
              methods.setValue("shodaibunTo", data.shodaibun ?? "");
              (async () => {
                await B000202ShohindaibunruiNmTo(methods, navigate, setMsg);
              })();
            }}
            onBlur={() => B000202ShohindaibunruiNmTo(methods, navigate, setMsg)}
            {...register(7)}
          />
          <STextField name="shohindaibunruiNmTo" disabled gridColumn="span 2" />

          <SLabel gridColumn="1">商品中分類コード</SLabel>
          <SNumberField
            name="shochubunFrom"
            code
            size={3}
            dialog={<B000202 />}
            handleSubmit={(data: any) => {
              methods.setValue("shodaibunFrom", data.shodaibun ?? "");
              methods.setValue("shochubunFrom", data.shochubun ?? "");
              (async () => {
                await B000202ShohindaibunruiNmFrom(methods, navigate, setMsg);
                await B000202ShohinchubunruiNmFrom(methods, navigate, setMsg);
              })();
            }}
            onBlur={() =>
              B000202ShohinchubunruiNmFrom(methods, navigate, setMsg)
            }
            {...register(8)}
          />
          <STextField
            name="shohinchubunruiNmFrom"
            disabled
            gridColumn="span 2"
          />
          <SText></SText>
          <SText>～</SText>
          <SNumberField
            name="shochubunTo"
            code
            size={3}
            dialog={<B000202 />}
            handleSubmit={(data: any) => {
              methods.setValue("shodaibunTo", data.shodaibun ?? "");
              methods.setValue("shochubunTo", data.shochubun ?? "");
              (async () => {
                await B000202ShohindaibunruiNmTo(methods, navigate, setMsg);
                await B000202ShohinchubunruiNmTo(methods, navigate, setMsg);
              })();
            }}
            onBlur={() => B000202ShohinchubunruiNmTo(methods, navigate, setMsg)}
            {...register(9)}
          />
          <STextField name="shohinchubunruiNmTo" disabled gridColumn="span 2" />

          <SLabel gridColumn="1">商品小分類コード</SLabel>
          <SNumberField
            name="shoshobunFrom"
            code
            size={3}
            dialog={<B000202 />}
            handleSubmit={(data: any) => {
              methods.setValue("shodaibunFrom", data.shodaibun ?? "");
              methods.setValue("shochubunFrom", data.shochubun ?? "");
              methods.setValue("shoshobunFrom", data.shoshobun ?? "");
              (async () => {
                await B000202ShohindaibunruiNmFrom(methods, navigate, setMsg);
                await B000202ShohinchubunruiNmFrom(methods, navigate, setMsg);
                await B000202ShohinshobunruiNmFrom(methods, navigate, setMsg);
              })();
            }}
            onBlur={() =>
              B000202ShohinshobunruiNmFrom(methods, navigate, setMsg)
            }
            {...register(10)}
          />
          <STextField
            name="shohinshobunruiNmFrom"
            disabled
            gridColumn="span 2"
          />
          <SText></SText>
          <SText>～</SText>
          <SNumberField
            name="shoshobunTo"
            code
            size={3}
            dialog={<B000202 />}
            handleSubmit={(data: any) => {
              methods.setValue("shodaibunTo", data.shodaibun ?? "");
              methods.setValue("shochubunTo", data.shochubun ?? "");
              methods.setValue("shoshobunTo", data.shoshobun ?? "");
              (async () => {
                await B000202ShohindaibunruiNmTo(methods, navigate, setMsg);
                await B000202ShohinchubunruiNmTo(methods, navigate, setMsg);
                await B000202ShohinshobunruiNmTo(methods, navigate, setMsg);
              })();
            }}
            onBlur={() => B000202ShohinshobunruiNmTo(methods, navigate, setMsg)}
            {...register(11)}
          />
          <STextField name="shohinshobunruiNmTo" disabled gridColumn="span 2" />

          <SText gridColumn="span 10"></SText>
          <SNormalButton
            onClick={handleClickSearchButton}
            label={labels.buttons.search}
            align="right"
            {...register(12)}
          />
        </SFrame>
      </FormProvider>

      <SFrame>
        <STable
          keyName="gyoNo"
          data={rows}
          columns={columns}
          tableRef={tableRef}
          handleDoubleClick={handleDoubleClickTableRow}
          width={1200}
          height={430}
          pageSize={15}
        />
      </SFrame>

      <FormProvider {...tabMethods}>
        <SFrame>
          <SEntryTab name="tab" handleOk={handleChangeTab}></SEntryTab>
          <SFrame gridTemplateColumns="8rem 18rem 8rem 8rem 8rem 8rem">
            <SLabel required>商品コード</SLabel>
            <SLabel>商品名</SLabel>
            <SLabel>相手コード</SLabel>
            <SLabel required>期間開始</SLabel>
            <SLabel>上代</SLabel>
            <SLabel>原価</SLabel>

            <SNumberField
              name="shohinCd"
              label="商品コード"
              code
              required
              disabled={tabMethods.getValues().tab === false}
              size={10}
              dialog={<B000200 />}
              handleSubmit={(data: any) => {
                tabMethods.setValue("shohinCd", data.shohinCd ?? "");
                tabMethods.setValue("shohinNm", data.shohinNmr ?? "");
              }}
              onBlur={() => B000200ShohinNm(tabMethods, navigate, setMsg)}
              {...register(15)}
            />
            <STextField name="shohinNm" disabled />
            <STextField name="aiteCd" size={10} {...register(16)} />
            <SDateField
              name="kikanFromymd"
              label="期間開始"
              required
              {...register(17)}
            />
            <SNumberField
              name="jodaitanka"
              size={9}
              align="right"
              required={tabMethods.getValues().tab === false}
              {...register(18)}
            />
            <SNumberField
              name="tanka"
              size={9}
              align="right"
              required={tabMethods.getValues().tab === false}
              {...register(19)}
            />

            {tabMethods.getValues().tab === true ? (
              <>
                <SNormalButton
                  label={labels.buttons.create}
                  gridRow="3"
                  gridColumn="6"
                  align="right"
                  {...register(20)}
                  dialog={
                    <SConfirmDialog
                      title={labels.dialog.createMasterTitle}
                      msg={labels.dialog.createConfirm}
                    />
                  }
                  dialogAction="confirm"
                  handleSubmit={handleCreate}
                />
              </>
            ) : (
              <>
                <SCancelButton
                  label={labels.buttons.linedeletion}
                  gridRow="3"
                  align="left"
                  {...register(21)}
                  dialog={
                    <SConfirmDialog
                      title={labels.dialog.deleteMasterTitle}
                      msg={labels.dialog.deleteConfirm}
                    />
                  }
                  dialogAction="confirm"
                  handleSubmit={handleDelete}
                />
                <SNormalButton
                  label={labels.buttons.update}
                  gridRow="3"
                  gridColumn="6"
                  align="right"
                  {...register(22)}
                  dialog={
                    <SConfirmDialog
                      title={labels.dialog.updateMasterTitle}
                      msg={labels.dialog.updateConfirm}
                    />
                  }
                  dialogAction="confirm"
                  handleSubmit={handleUpdate}
                />
              </>
            )}
          </SFrame>
        </SFrame>
      </FormProvider>
    </>
  );
};
